import * as React from 'react';

import { ITooltipProps } from '../types';
import { TooltipIcon } from 'src/components';

export const InformationTooltips = ({
  item,
  isTargetChecking,
  targetCheckResult,
}: ITooltipProps) => (
  <>
    {item.helpMessage && !item.showHelpMessagePermanently && (
      <TooltipIcon className="ml-4" width="w-128" text={item.helpMessage} />
    )}
    {item.hasError && (
      <TooltipIcon
        className="ml-2"
        type="warning"
        width="w-64"
        text={item.validationMessage || item.errorMessage}
      />
    )}
    {item.isTargetUrl &&
      (targetCheckResult && !isTargetChecking ? (
        <TooltipIcon
          className="ml-2"
          type={targetCheckResult.success ? 'success' : 'warning'}
          width="w-64"
          text={targetCheckResult.message}
        />
      ) : (
        <TooltipIcon
          className="ml-2"
          type="loading"
          width="w-64"
          text={isTargetChecking ? 'Checking Target URL' : 'Not checked yet'}
          isLoading={isTargetChecking}
        />
      ))}
  </>
);



// WEBPACK FOOTER //
// ./src/views/LinkCreate/components/InformationTooltips.tsx